
export const deserializeDedicatedCluster = (item) => {
  const attrs = item.attributes || {};
  const relationships = item.relationships || {};

  return {
    id: item.id,
    region: attrs.region?.trim() || "",
    domainName: attrs.domain_name?.trim() || "",
    name: attrs.name?.trim() || "",
    console_url: attrs.console_url?.trim() || "",
    health: attrs.health ?? null,
    status: attrs.status || "",
    org_id: relationships.organization?.data?.id || null,
    subscriptionId: relationships.subscription?.data?.id || null,
    payment_status: attrs.payment_status,
    creator_id: attrs.creator_id ?? "",
    created_at: attrs.created_at ?? "",
    updatedAt: attrs.updated_at ?? "",
    version: attrs.version ?? ""
  };
};